import { z } from "zod";

import { destinationSchema } from "@features/data-export-v2/destination/destination-schema";
import { reportDataSchema } from "@features/data-export-v2/report-data/report-data-schema";
import { triggerSchema } from "@features/data-export-v2/trigger/trigger-schema";

export const scheduledExportFormSchema = z.object({
  reportData: reportDataSchema,
  destination: destinationSchema,
  trigger: triggerSchema,
});
